/** True when the page is being loaded by the build-time prerender snapshotter.
 *  Gates non-deterministic surfaces (clocks, timers, typed animations) so
 *  snapshots are stable and honest. */
export function isPrerender(): boolean {
  if (typeof window === 'undefined') return true
  return new URLSearchParams(window.location.search).has('__prerender')
}
